import { Box, Button, Snackbar, Typography } from "@mui/material";
import CustomButton from "../../../MUI_custom_component/Button/CustomButton";
import { useNavigate } from "react-router-dom";
import { InsuranceType } from "../../Beneficiary/constants";
import { trackAnalyticsEvent } from "../../../../utils/clevertap";
import { useSelector } from "react-redux";
import { useState } from "react";
import CustomSnackbar from "../../../MUI_custom_component/SnackBar";

// Separate component for snackbar to avoid event propagation issues
const BenefitSnackbar = ({ snackbar, setSnackbar }) => {
    const handleClose = () => {
        setSnackbar((prev) => ({ ...prev, open: false }));
    };

    return (
        <div onClick={(e) => e.stopPropagation()}>
            <CustomSnackbar
                open={snackbar.open}
                onClose={handleClose}
                message={snackbar.message}
                severity={snackbar.severity}
                actionable={snackbar.actionable}
                type={snackbar.type}
            />
        </div>
    );
};

const BenefitCard = ({ benefit, selectedManufacturer, selectedCompanyEntity }) => {
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
        actionable: null,
        type: 'default',
    });
    const navigate = useNavigate();
    const userData = useSelector(state => state.user?.userData);

    const ROUTES = {
        LI_DETAILS: () => `/benefits/insurance-detail`,
        MI_DETAILS: () => `/benefits/insurance-detail`,
        GAP_DETAILS: () => `/benefits/gap-detail`,
        SHOP_INSURANCE_DETAILS: (id) => `benefits/shop-insurance-detail`,
    };

    const handleViewDetails = () => {
        if (!benefit?.action_button?.show){
            if (benefit?.nudges) {
                setSnackbar({
                    open: true,
                    message: benefit?.nudges?.info_text,
                    severity: 'error',
                    type : benefit?.nudges?.type || 'default',
                    actionable: {
                        label: 'Add',
                            onClick: () => {
                                navigate('/beneficiary');
                                setSnackbar((prev) => ({ ...prev, open: false }));
                            },
                        },
                    });
                }

            return;
        };
        
        // Track MY_BENEFIT_CURRENT_POLICY_CLICK event
        trackAnalyticsEvent('MY_BENEFIT_CURRENT_POLICY_CLICK', {
            manufacturer_id: userData?.manufacturer_id || '',
            benefit_type: benefit?.value || '',
            benefit_status: benefit?.status?.label || '',
            benefit_amount: benefit?.amount || ''
        });

        const { value } = benefit;
        switch (value) {
            case InsuranceType.LIFE_INSURANCE:
                navigate(ROUTES.LI_DETAILS(), { state: { insuranceType: value, selectedManufacturer: selectedManufacturer, selectedCompanyEntity: selectedCompanyEntity  } });
                break;
            case InsuranceType.MEDICAL_INSURANCE:
                navigate(ROUTES.MI_DETAILS(), { state: { insuranceType: value, selectedManufacturer: selectedManufacturer, selectedCompanyEntity: selectedCompanyEntity} });
                break;
            case InsuranceType.GAP_BENEFIT:
                navigate(ROUTES.GAP_DETAILS(), { state: { insuranceType: value, selectedManufacturer: selectedManufacturer, selectedCompanyEntity: selectedCompanyEntity } });
                break;
            case InsuranceType.SHOP_INSURANCE:
                navigate(ROUTES.SHOP_INSURANCE_DETAILS(), { state: { insuranceType: value, selectedManufacturer: selectedManufacturer, selectedCompanyEntity: selectedCompanyEntity } });
                break;
            default:
                console.warn("Unknown benefit type:", value);
        }
    };
    return (
        <Box onClick={handleViewDetails} sx={{ p: 1, 
            border: '1px solid #D9D9D9',
            borderRadius: 2,
            minHeight: {xs: 110, md: 130},
            cursor: benefit?.action_button?.show && 'pointer',
            background: '#FFFFFF'
        }}>
            <Typography variant="h3" 
                sx={{ 
                    fontWeight:600,
                    display:  'block',
                    color: benefit?.status?.type === 'success' ? '#008000' : '#CC0000',
                    textAlign: 'right',
                }}
            >{benefit?.status?.label}</Typography>
            <Box sx={{ display: "flex" }}>
                <Box
                    component="img"
                    src={benefit?.logo_url}
                    alt="logo"
                    sx={{
                        maxHeight: { xs: 32, md: 50 },
                        maxWidth: { xs: 32, md: 50 },
                    }}
                />
                <Box sx={{ display: "flex", flexDirection: "column", ml: { xs: 0.8, md: 1 } }}>
                    <Typography variant="labelD">{benefit?.benefit_name}</Typography>
                    <Typography variant="body1" sx={{ color: '#636363'}}>{benefit?.amount}</Typography>
                    <Typography sx={{ color: benefit?.status?.color, fontWeight: "bold" }}>{benefit?.status?.display_name}</Typography>
                </Box>
            </Box>
            {benefit?.action_button?.show && (
                <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>                
                    <CustomButton
                        variant="text"
                        color="warning"
                        label="View Details"
                    />
                </Box>
            )}
            <BenefitSnackbar snackbar={snackbar} setSnackbar={setSnackbar} />
        </Box>
    );
};

export default BenefitCard;